import React from 'react';

export default function ProblemBlock() {
  return (
    <section className="w-full bg-black text-white py-20 px-6 md:px-10">
      <div className="max-w-5xl mx-auto space-y-12">

        {/* Section Title */}
        <h2 className="text-3xl md:text-4xl font-bold text-center">
          What Financial Professionals Face Today
        </h2>

        {/* Problem Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 pt-10 text-gray-300 text-base">

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6 shadow-sm">
            <h3 className="text-xl font-semibold text-white mb-2">🔒 Lack of Trust & Identity</h3>
            <p>
              Fake profiles, unverifiable credentials, and no consistent digital ID across platforms
              — professionals struggle to be seen as credible.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6 shadow-sm">
            <h3 className="text-xl font-semibold text-white mb-2">🔧 Scattered Tools, Zero Interoperability</h3>
            <p>
              Most pros jump between 5+ platforms daily — from charting to hiring to publishing — none of which talk to each other.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6 shadow-sm">
            <h3 className="text-xl font-semibold text-white mb-2">🧩 No Role-Based Infrastructure</h3>
            <p>
              Platforms ignore the nuance of roles — a fund manager, signal provider, or trading educator each needs different tools and workflows.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6 shadow-sm">
            <h3 className="text-xl font-semibold text-white mb-2">💸 Broken Monetization Models</h3>
            <p>
              Educators are stuck with subscriptions. Analysts struggle to get visibility. Signal providers get banned or ignored. Most end up underpaid.
            </p>
          </div>

        </div>

        {/* Why It Hasn’t Been Solved */}
        <div className="text-center max-w-3xl mx-auto pt-14 text-gray-400">
          <h3 className="text-2xl font-semibold text-white mb-4">Why Has No One Fixed This?</h3>
          <p>
            Most platforms are built either for retail users or enterprise finance — not the people working between the two.
            M2T is the first to align trust, tools, and monetization specifically around verified financial roles.
          </p>
        </div>

      </div>
    </section>
  );
}
